import { AUTHENTICATED_ACCESS_PATHS, STATUS_CODES, SUBSCRIBED_ACCESS_PATHS } from 'utils/Constants'
import { getMiddleware, MiddlewareFunction } from './index'
import { siteDomain } from 'utils/CareguideDomains'
import { getAutologinRedirectUrl } from './utils'

import ViewerQuery from './query.viewer.middleware.gql'

export const handleAutoLoginRedirect: MiddlewareFunction = async (data, next) => {
  const { nextContext } = data
  const autologinToken = nextContext?.query?.altkn
  const { req, res } = nextContext

  if (!autologinToken) {
    return next()
  }

  const gqlEndpoint = process.env.CGC_WEB_CGC_APP_URL || 'http://cgc-app:3000'
  const url = `${gqlEndpoint}/autologin?autologin_token=${autologinToken}`
  const btoa = require('btoa')
  // eslint-disable-next-line no-undef
  const response = await fetch(url, {
    headers: {
      Authorization: `Basic ${btoa('careguidebeta:testdemo')}`,
      'x-cgc-domain': siteDomain(nextContext),
    },
  })
  const responseCookies = response.headers.get('set-cookie')
  const jsonResponse = await response.json()
  const autologinRedirectUrl = getAutologinRedirectUrl(req, autologinToken)
  let headers = { Location: autologinRedirectUrl }

  if (jsonResponse.success === true) {
    const setCookie = require('set-cookie-parser')
    const splitCookieHeaders = setCookie.splitCookiesString(responseCookies)
    // @ts-ignore
    headers = { ...headers, 'Set-Cookie': splitCookieHeaders }
  }

  res.writeHead(STATUS_CODES.CODE302, headers)
  res.end()

  return {
    isServerSideRedirect: true,
    errorCode: null,
  }
}

export const handleUnauthorizedAccess: MiddlewareFunction = async (
  { nextContext, apolloClient },
  next
) => {
  const { data } = await apolloClient.query({
    query: ViewerQuery,
  })

  const unauthorizedMiddlewares = [handleLoggedOutAccess, handleBasicAccess]

  const result = await getMiddleware(unauthorizedMiddlewares)({
    data,
    nextContext,
    apolloClient,
  })

  if (!result) {
    return next()
  } else {
    return result
  }
}

export const handleLoggedOutAccess: MiddlewareFunction = async ({ data, nextContext }, next) => {
  const { req, res } = nextContext
  const isAuthenticatedPath = AUTHENTICATED_ACCESS_PATHS.find((p) => req?.url.startsWith(p))

  if (!isAuthenticatedPath) {
    return next()
  }

  if (!data?.viewer?.user?.userId) {
    res.writeHead(STATUS_CODES.CODE302, {
      Location: `/log-in`,
    })
    res.end()

    return {
      isServerSideRedirect: true,
      errorCode: null,
    }
  }
  return next()
}

export const handleBasicAccess: MiddlewareFunction = async ({ data, nextContext }, next) => {
  const { req, res } = nextContext
  const isUpgradedPath = SUBSCRIBED_ACCESS_PATHS.find((p) => req?.url?.startsWith(p))

  if (!isUpgradedPath) {
    return next()
  }

  if (!data?.viewer?.isSubscribed) {
    res.writeHead(STATUS_CODES.CODE302, {
      Location: `/upgrade`,
    })
    res.end()

    return {
      isServerSideRedirect: true,
      errorCode: null,
    }
  }
  return next()
}
